<!-- <p>scanned-assets-card works!</p> -->
<!-- <p>lodged-complaints-card works!</p> -->
<div class="mobile-table-card-wrapper">
  <div
    *ngFor="let asset of assetsList; let i = index"
    class="mobile-table-card-container"
  >
    <div class="card-content">
      <div>
        Serial No.: <b>{{ i + 1 }}</b>
      </div>
      <div>
        Asset Type : <b>{{ asset.DeviceType }}</b>
      </div>
      <div>
        Asset Url :
        <b>{{ asset.IP }} </b>
      </div>
    </div>
    <div class="card-action">
      <!-- <button (click)="onShowDetails(asset.IP)" mat-raised-button>
        {{ "Details" }}
      </button> -->
      <button (click)="onShowDetails(asset)" mat-raised-button>
        <mat-icon *ngIf="rtspUrl != asset.IP">add</mat-icon>
        <mat-icon *ngIf="isShowAssetDetails && asset && rtspUrl == asset.IP"
          >remove</mat-icon
        >
      </button>
    </div>
  </div>
</div>
